// lib/helpers/timeHelpers.js
import { format, isToday } from 'date-fns';

/**
 * Format time "HH:mm" → "h:mm a" (contoh: 10:00 → 10:00 AM)
 * @param {string} time - waktu dalam format HH:mm
 * @returns {string} waktu terformat
 */
export function formatTimeDisplay(time) {
  if (!time) return '';
  const [hour, minute] = time.split(':').map(Number);
  const date = new Date();
  date.setHours(hour, minute);
  return format(date, 'h:mm a');
}

/**
 * Hitung durasi menit dari start & end time.
 * Jika start/end kosong, fallback ke fallbackMinutes (misal dari class.duration)
 * @param {string} startTime - waktu mulai (HH:mm)
 * @param {string} endTime - waktu selesai (HH:mm)
 * @param {number} [fallbackMinutes] - fallback durasi
 * @returns {string} durasi dalam format "xxx mins"
 */
export function calculateDurationMinutes(startTime, endTime, fallbackMinutes) {
  if (startTime && endTime) {
    const [startHour, startMin] = startTime.split(':').map(Number);
    const [endHour, endMin] = endTime.split(':').map(Number);

    let totalMinutes = endHour * 60 + endMin - (startHour * 60 + startMin);

    // Jika minus (melewati tengah malam), tambahkan 24 jam
    if (totalMinutes < 0) totalMinutes += 24 * 60;

    return `${totalMinutes} mins`;
  }

  if (fallbackMinutes) return `${fallbackMinutes} mins`;
  return '';
}

export function formatPickDate(paramsDate) {
  const labelToday = isToday(paramsDate) ? 'Today, ' : '';
  return `${labelToday}${format(paramsDate, 'EEEE d MMMM')}`;
}
